const skills = [
  "C#",
  ".NET",
  "SQL Server",
  "Postgres",
  "EF Core",
  "Azure",
  "AWS",
  "Microservices",
  "REST",
  "GraphQL",
  "Vue.js",
  "React",
  "DevOps",
  "CI/CD",
  "CQRS",
  "Docker",
  "Kubernetes",
  "Terraform",
  "IaC",
  "Git",
  "SCRUM",
  "TDD",
  "DDD",
];

export { skills };
